import React, { Component } from 'react';
import { Link, useLocation } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import { List } from 'react-content-loader'
import ReactHtmlParser from 'react-html-parser';
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar'
import "./program.css"
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import tmp_img from '../assets/grey.jpg'
import NewFooter from '../footer/newfooter';
import NewHeader from '../header/newheader';

let index = 0
class Programs extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.state = {
            mission: '',
            content: '',
            tab: 1
        }

    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    list() {
        Axios(BASE + 'jsonapi/node/page?filter[title]=Research Clusters', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                this.setState({
                    descrption: data.data.data
                })
                console.log('cisdata', data.data.data)
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    componentWillMount() {
        this.list()
        Axios.get(BASE + 'jsonapi/taxonomy_term/programs?include=field_image&filter[display][group][conjunction]=OR&filter[title][condition][path]=field_frontend_display&filter[title][condition][value]=0&&filter[title][condition][memberOf]=display&filter[novalue][condition][path]=field_frontend_display&filter[novalue][condition][operator]=IS NULL&filter[novalue][condition][memberOf]=display')
            .then((data) => {
                this.setState({
                    programs: data.data.data,
                    programincluded: data.data.included
                })
                console.log('programs', data.data)
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    render() {
        const cluster = [
            { name: 'Critical Issues in Islamic Studies', link: process.env.PUBLIC_URL + '/cluster/c11.jpg' },
            { name: 'Islamic Finance and Sustainable Economies', link: process.env.PUBLIC_URL + '/cluster/c22.jpg' },
            { name: 'Islamic Civilization: Foundations and Institutions', link: process.env.PUBLIC_URL + '/cluster/c33.jpg' },
            { name: 'Bibliographic Capacity in Islamic Studies', link: process.env.PUBLIC_URL + '/cluster/c44.jpg' },
            { name: 'Islam, Reform and Global Affairs', link: process.env.PUBLIC_URL + '/cluster/c55.jpg' },
            { name: 'Islam and Applied Ethics', link: process.env.PUBLIC_URL + '/cluster/c66.jpg' },
            { name: 'Islamic Art, Architecture and Urbanity', link: process.env.PUBLIC_URL + '/cluster/c77.jpg' }
        ]
        return (
            <>
                <NewHeader />
                <div className='formrea clusterpage yourwork sub_work'>
                    <div className="title-banner">
                        <h1 className="heading-one bold white-text">CIS Programs</h1>
                    </div>
                    <div className='container'>

                        <div className="listing">
                            <div className='top-contents'>
                                <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /> </Link><img className='rightarrow' src={crumbarrow} />Research<img className='rightarrow' src={crumbarrow} /> <Link to={'/programs'} className='gray-text'>CIS Programs</Link></div>
                                {/* <TopBar data={'data1'} /> */}
                            </div>
                            {this.state.descrption ? this.state.descrption[0].attributes.body ?
                                <div className="body-two gray-text program-desc text-justify">
                                    With an aim to be the leading institution in the field of Islamic Studies, the College of Islamic Studies offers six programs. The multi-disciplinary programs at
                                    CIS are curated to meet the contemporary needs of the industry as well as to make the graduates ready to address the challenges of the future. The programs at CIS include a PhD, a first of its kind program on
                                </div>
                                : '' : ''}

                            {this.state.programs ?
                                <div className="col-sm-6 mission clusterlist programs-list">
                                    {this.state.programs.map((inst, ind) => {
                                        let aa = inst.attributes.name.toString()
                                        let links = aa.replace(/ /g, '-')
                                        let image = inst.relationships.field_image.data ? this.state.programincluded.filter(x => x.id === inst.relationships.field_image.data.id)[0].attributes.uri.url : ""
                                        return (
                                            <div className="program-info" style={{ marginRight: (ind + 1) % 4 === 0 ? "0%" : "" }}>
                                                <div className="program-image-container">
                                                    <img src={image ? BASE + image : tmp_img} />
                                                </div>
                                                {inst.attributes.field_link ? <a href={`${inst.attributes.field_link.uri}`} target="_blank"><p className='subtitle-one blue-text text-center bold'>{inst.attributes.name}</p></a> : <p className='subtitle-one blue-text text-center bold'>{inst.attributes.name}</p>}
                                                {/* <p className='a-body'>{ReactHtmlParser(inst.attributes.body.value)}</p> */}
                                            </div>
                                        )
                                    })}
                                </div> : <List />
                            }
                        </div>
                    </div>
                </div >
                <NewFooter />
            </>
        )


    }

}


export default Programs;
